import { withApollo } from '@jusbrasil-web/core-apollo'
import { GetServerSideProps } from 'next'

import {
  COMMENTS_PARENT_DOCUMENT_ROOT_QUERY,
  CommentsParentDocumentRootQuery,
  CommentsParentDocumentRootQueryVariables,
} from '../../queries'

export function CommentsRedirectPage() {
  return null
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { docId } = ctx.query

  if (!docId || typeof docId !== 'string') {
    return {
      notFound: true,
    }
  }

  const { client } = withApollo(ctx)

  try {
    const { data } = await client.query<
      CommentsParentDocumentRootQuery,
      CommentsParentDocumentRootQueryVariables
    >({
      query: COMMENTS_PARENT_DOCUMENT_ROOT_QUERY,
      variables: { docId },
    })

    const document = data?.root?.document
    const parentDocumentUrl = document?.parentDocument?.url

    if (!parentDocumentUrl) {
      return {
        notFound: true,
      }
    }

    const toURL = `${parentDocumentUrl}#comments`

    return {
      redirect: {
        destination: toURL,
        permanent: true,
      },
    }
  } catch (error) {
    console.error('Error fetching parent document URL: ', error)
    return {
      notFound: true,
    }
  }
}

export const CommentsRedirectPageExports = { getServerSideProps }
